/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ProductResponse } from '../../models/product-response';
import { ProductUpdateInput } from '../../models/product-update-input';

export interface CatalogEntriesProductsCatalogEntryIdPut$Params {
  'Active-Tenant-Identifier': string;
  catalogEntryId: string;
      body: ProductUpdateInput
}

export function catalogEntriesProductsCatalogEntryIdPut(http: HttpClient, rootUrl: string, params: CatalogEntriesProductsCatalogEntryIdPut$Params, context?: HttpContext): Observable<StrictHttpResponse<ProductResponse>> {
  const rb = new RequestBuilder(rootUrl, catalogEntriesProductsCatalogEntryIdPut.PATH, 'put');
  if (params) {
    rb.header('Active-Tenant-Identifier', params['Active-Tenant-Identifier'], {});
    rb.path('catalogEntryId', params.catalogEntryId, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/hal+json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ProductResponse>;
    })
  );
}

catalogEntriesProductsCatalogEntryIdPut.PATH = '/catalog-entries/products/{catalogEntryId}';
